import { Controller } from "@hotwired/stimulus";

// Bridges Bootstrap modal events to a turbo-frame inside the modal body.
// Bootstrap's modal data-API (data-bs-toggle="modal") preventDefaults the
// click, so a sibling data-turbo-frame on the same trigger never fires.
// Instead, listen for show.bs.modal and pull the URL from the trigger's
// href, then set frame.src so Turbo fetches lazily on open.
//
// Usage:
//   <div data-controller="turbo-modal"
//        data-turbo-modal-frame-id-value="modal-body">
//     <div class="modal fade" id="some-modal">
//       ...
//       <turbo-frame id="modal-body">Loading…</turbo-frame>
//     </div>
//   </div>
//
//   <a href="/some/url" data-bs-toggle="modal" data-bs-target="#some-modal">Open</a>
export default class extends Controller {
  static values = { frameId: String };

  connect() {
    this.boundLoadFrame = this.loadFrame.bind(this);
    this.boundClearFrame = this.clearFrame.bind(this);
    this.element.addEventListener("show.bs.modal", this.boundLoadFrame);
    this.element.addEventListener("hidden.bs.modal", this.boundClearFrame);
  }

  disconnect() {
    this.element.removeEventListener("show.bs.modal", this.boundLoadFrame);
    this.element.removeEventListener("hidden.bs.modal", this.boundClearFrame);
  }

  loadFrame(event) {
    const trigger = event.relatedTarget;
    if (!trigger) return;
    const href = trigger.getAttribute("href");
    if (!href) return;
    const frame = this.findFrame();
    if (!frame) return;

    // Removing then setting src ensures Turbo re-fetches even when the
    // user reopens with the same trigger.
    frame.removeAttribute("src");
    frame.setAttribute("src", href);
  }

  clearFrame() {
    const frame = this.findFrame();
    if (!frame) return;

    frame.removeAttribute("src");
    frame.innerHTML = '<p class="text-muted text-center my-3">Loading…</p>';
  }

  findFrame() {
    return this.element.querySelector(`turbo-frame#${this.frameIdValue}`);
  }
}
